export default __webpack_public_path__ + "static/media/icon-avatar-player.79ed550f.svg";